export default "__VITE_ASSET__XEOD6bUe__"